export default __webpack_public_path__ + "static/media/icon-person-success.92f0965a.svg";